 <style>
	.p2 {
		font-family: 'Press Start 2P';
		font-size: 70%;
	}
	.stole {
		text-decoration: line-through;
	}
	ul {
		margin-top: 0.5rem;
		padding-left: 1.2rem;
	}
	li {
		margin: 0 0 0.5rem 0;
	}
 </style>

<p>some other things to note:</p>
<ul>
  <li>i liked the <span class="p2">font</span> from <a href="https://web3isgoinggreat.com/" target="_blank">web3isgoinggreat.com</a> so i <span class="stole">stole</span> borrowed it</li>
</ul>